module.exports = __webpack_public_path__ + "media/images/rocket-3cb57e0f5f7b15be925e0a242913cdca.png";